<script lang="ts">
  import type { ComponentProps } from 'svelte';
  import ItemImage from './item-image.svelte';
  import { idToCrafts } from './stores';
  import LL, { locale } from '$i18n/i18n-svelte';
  import RawItemImage from './raw-item-image.svelte';
  import { getItemName } from './translation';

  export let id: number;
  export let imageSize: ComponentProps<ItemImage>['size'] = 3;
  export let noTooltip = false;

  $: crafts = $idToCrafts.get(id) ?? [];
</script>

<li class="item-build-tree-node">
  <a class="item" href="/{$locale}/database/items/{id}">
    {#if noTooltip}
      <RawItemImage {id} size={imageSize} />
    {:else}
      <ItemImage {id} size={imageSize} />
    {/if}
    {getItemName($LL, id)}
  </a>
  {#if crafts.length > 0}
    <ul>
      {#each crafts as craft}
        <svelte:self id={craft.sourceItemId} {imageSize} />
      {/each}
    </ul>
  {/if}
</li>

<style lang="postcss">
  .item-build-tree-node {
    display: flex;
    flex: auto;
    flex-direction: column;
    align-items: center;
    gap: var(--space-2);
    position: relative;
    padding-top: var(---node-gap);
    padding-left: var(--space-1);
    padding-right: var(--space-1);

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      height: var(---node-gap);
      right: 50%;
      width: 50%;
      border-top: var(---line);
    }

    &::after {
      left: 50%;
      border-left: var(---line);
    }

    &:only-of-type {
      padding: 0;
      &::before,
      &::after {
        display: none;
      }
    }

    &:first-of-type {
      &::before {
        border: 0 none;
      }
      &::after {
        border-top-left-radius: var(---radius);
      }
    }

    &:last-of-type {
      &::before {
        border-right: var(---line);
        border-top-right-radius: var(---radius);
      }
      &::after {
        border: 0 none;
      }
    }
  }

  .item {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    align-items: center;
    color: var(--text);
  }

  ul {
    display: flex;
    position: relative;
    padding-inline-start: 0;
    padding-top: var(---node-gap);

    /* 수직선 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      height: var(---node-gap);
      left: 50%;
      width: 0;
      border-left: var(---line);
    }
  }
</style>
